import { withSearch } from '@elastic/react-search-ui';
import MultiChoiceAsyncSelect from '../../../components/filter/MultiChoiceAsyncSelect';

function ArchiveBuildingTypeFilter({ addFilter, removeFilter, filters }) {
  return (
    <MultiChoiceAsyncSelect
      addFilter={addFilter}
      fieldId="buildingType"
      filters={filters}
      formHint="For example, fortress, chapel, garden, barrow"
      id="building-type"
      label="Site type"
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, filters }) => ({
  addFilter,
  removeFilter,
  filters,
}))(ArchiveBuildingTypeFilter);
